import styled from '@emotion/styled';
import MuiHelpIcon from '@material-ui/icons/HelpOutline';

import COLORS from '$variables/colors';
import { typography, spacing } from '$variables/theme';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px ${spacing.xLarge} ${spacing.xLarge};
`;

export const Divider = styled.div`
  height: 1px;
  width: 456px;
  margin: ${spacing.xLarge} 0;
  background-color: ${COLORS.grey};
`;

export const SecondaryTitleRow = styled.div`
  width: 100%;
`;

export const Description = styled.div`
  color: ${COLORS.shadow5};
  font-weight: ${typography.fontWeightRegular};
  font-size: 12px;
  line-height: 16px;
  margin-top: ${spacing.xxSmall};
`;

export const Subtitle = styled.div`
  color: ${COLORS.default};
  font-weight: ${typography.fontWeightMedium};
  font-size: 14px;
`;

export const HelpIcon = styled(MuiHelpIcon)`
  height: 16px;
  width: 16px;
  color: ${COLORS.grey1};
`;

export const Container = styled.div`
  margin-top: ${spacing.small};
  width: 100%;
`;

export const WarningMessage = styled.div`
  padding: ${spacing.xxSmall};
  border-radius: ${spacing.xxSmall};
  text-align: center;
  color: ${COLORS.warning};
  background-color: ${COLORS.warningBg};
`;

export const ReadOnlyWarning = styled.div`
  margin-bottom: ${spacing.xLarge};
  width: 100%;
`;
